import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Tab, TabPane } from "semantic-ui-react";
// Actions
import { sendEmailUser, sendEmailUserGroup } from "../../redux/actions/Email";
import { setUserApproval, getUserGroup, deactivateUser, reactivateUser } from "../../redux/actions/User";
// Components
import { Button } from "../atoms/Button";
import { ReviewTable } from "../organisms/Table";
// Constants
import { newStatus } from "../../model/Table";
import i18nstring, { strings } from "../../i18n";
import { Roles } from "../../Shared/Constants/Roles";
// Themes
import "./PageStyles.scss";
import { tabMenuItem } from "../atoms/TabMenuItem";

function GardenerReview({ gardeners, gardenersFetched, attemptGetUsers, attemptApproveUser, attemptDeactivateUser, attemptReactivateUser, attemptSendEmail }) {
  useEffect(() => {
    if (!gardenersFetched) {
      attemptGetUsers(Roles.PRODUCER);
    }
  }, []);

  const changeApproval = (status, userIds, silent = false) => {
    if (status === newStatus.DEACTIVATE) {
      return attemptDeactivateUser(userIds[0]);
    }
    if (status === newStatus.REACTIVATE) {
      return attemptReactivateUser(userIds[0]);
    }
    return attemptApproveUser(status, userIds, silent);
  };

  const sendEmail = (userId, body, subject) =>
    attemptSendEmail([userId], body, subject);

  const deactivatedUsers = gardeners.filter(u => u.deactivated === true);
  const pendingUsers = gardeners.filter(u => !u.deactivated && u.approvalStatus === newStatus.PENDING);
  const approvedUsers = gardeners.filter(u => !u.deactivated && u.approvalStatus === newStatus.APPROVED);

  const panes = [
    {
      menuItem: tabMenuItem(i18nstring(strings.PENDING_TAB_LABEL), pendingUsers.length, newStatus.PENDING),
      render: () => (
        <TabPane attached={false}>
          <ReviewTable
            users={pendingUsers}
            tabStatus={newStatus.PENDING}
            changeApproval={changeApproval}
            sendEmail={sendEmail}
          />
        </TabPane>
      )
    },
    {
      menuItem: tabMenuItem(i18nstring(strings.APPROVED_TAB_LABEL), approvedUsers.length, newStatus.APPROVED),
      render: () => (
        <TabPane attached={false}>
          <ReviewTable
            users={approvedUsers}
            tabStatus={newStatus.APPROVED}
            changeApproval={changeApproval}
            sendEmail={sendEmail}
          />
        </TabPane>
      )
    },
    {
      menuItem: tabMenuItem(i18nstring(strings.DEACTIVATED_TAB_LABEL), deactivatedUsers.length, newStatus.DEACTIVATE),
      render: () => (
        <TabPane attached={false}>
          <ReviewTable
            users={deactivatedUsers}
            tabStatus={newStatus.DEACTIVATE}
            changeApproval={changeApproval}
            sendEmail={sendEmail}
          />
        </TabPane>
      )
    }
  ];

  return (
    <div className="main_container_section">
      <div className="review_toolbar">
        <div className="review_page_info">
          <span className="review_page_subtitle">
            {i18nstring(strings.GARDENER_REVIEW_DESCRIPTION)}
          </span>
        </div>
        <Button onClick={() => attemptGetUsers(Roles.PRODUCER)}>
          {i18nstring(strings.REFRESH)}
        </Button>
      </div>
      <div className="review_tabs_container">
        <Tab
          menu={{ secondary: true, pointing: true }}
          panes={panes}
          defaultActiveIndex={1}
        />
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  gardeners: state.user.gardeners,
  gardenersFetched: state.user.gardenersFetched,
  user: state.account.user
});

const mapDispatchToProps = dispatch => ({
  attemptApproveUser: (status, userIds, silent = false) =>
    dispatch(setUserApproval(status, Roles.PRODUCER, userIds, silent)),
  attemptDeactivateUser: userId => dispatch(deactivateUser(userId, Roles.PRODUCER)),
  attemptReactivateUser: userId => dispatch(reactivateUser(userId, Roles.PRODUCER)),
  attemptGetUsers: userGroup => dispatch(getUserGroup(userGroup)),
  attemptSendEmail: (userIds, body, subject) =>
    dispatch(sendEmailUser(userIds, body, subject)),
  attemptSendEmailToGroup: (userGroup, body, subject) =>
    dispatch(sendEmailUserGroup(userGroup, body, subject))
});

export default connect(mapStateToProps, mapDispatchToProps)(GardenerReview);
